var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var SvgClosePopup = function SvgClosePopup(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m10.41 9 6.3-6.29a1.004 1.004 0 0 0-1.42-1.42L9 7.59l-6.29-6.3a1.004 1.004 0 1 0-1.42 1.42L7.59 9l-6.3 6.29a.999.999 0 0 0 0 1.42 1 1 0 0 0 1.42 0L9 10.41l6.29 6.3a1.001 1.001 0 0 0 1.639-.325 1 1 0 0 0-.22-1.095L10.41 9Z",
    fill: "#fff"
  })));
};

export default SvgClosePopup;